<template>
    <div class="ssssss">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">我的分享</p>
			</h1>
		</header>
		<div class="dd_buti">
			<button class="dd_but" id="dd_butzj">专辑列表</button><button class="dd_buta" id="dd_butlist">章节列表</button>
		</div>
		<!-- 订单 -->
		<!-- 1 -->
		<div class="dd_cntx1">
			<!--  -->
			<div class="dd_cntx">
				<div class="dd_cntxa" v-for="item in list1">
					<img src="../../img/listen.png" class="dd_cntxaimg">
					<p class="dd_cntxap" id="dd_cntxaf">{{item.b_bookname}}</p>
					<!-- <p class="dd_cntxap" id="dd_cntxafa">章节:<span>1 小人国奇遇-海上遇险</span></p> -->
					<p class="dd_cntxap" id="dd_cntxafb">分享点击数:<span>{{item.sh_num}}</span></p>
					<p class="dd_cntxap" id="dd_cntxapl" v-if="item.b_is_free == '1'">￥{{item.b_price}}</p>
					<p class="dd_cntxap" id="dd_cntxapl" v-else="item.b_is_free == '2'">免费</p>
				</div>
			</div>
			<!--  -->
		</div>
		
		<!-- 2 -->
		<div class="dd_cntx2">
			
			<div class="dd_cntx" v-for="items in list2">
				<div class="dd_cntxa">
					<img :src="items.b_pic" class="dd_cntxaimg">
					<p class="dd_cntxap" id="dd_cntxaf">{{items.bp_bookname}}</p>
					<p class="dd_cntxap" id="dd_cntxafa">章节:<span>{{items.bp_title}}</span></p>
					<p class="dd_cntxap" id="dd_cntxafb">分享点击数:<span>{{items.sh_num}}</span></p>
					<p class="dd_cntxap" id="dd_cntxapl" v-if="items.bp_is_free == '1'">￥{{items.bp_price}}</p>
					<p class="dd_cntxap" id="dd_cntxapl" v-if="items.bp_is_free == '2'">免费</p>
				</div>
			</div>
	
		</div>
		
		<!-- 订单end -->
		<p class="dd_indexend">已显示全部</p>
    </div>
</template>
<script>
import appNav from "../common/appNav";
import { CURL } from "../../lib/url.js";
import $ from 'jquery';
export default {
	components: {
	  appNav
	},
	data() {
	  return {
	    params: '',
	    list1:[],
	    list2:[],
	  }
	},
	created(){
      var openid=localStorage.getItem("openid");
      this.openid = openid;
   },
	mounted(){
		$('#dd_butzj').click(function(){
			$('.dd_but').css('color','#00a8d9');
			$('.dd_buta').css('color','#000');
			$('.dd_cntx1').show();
			$('.dd_cntx2').hide();
		})
		$('#dd_butlist').click(function(){
			$('.dd_buta').css('color','#00a8d9');
			$('.dd_but').css('color','#000');
			$('.dd_cntx1').hide();
			$('.dd_cntx2').show();
		})
		this.getAjax();
	},
	methods:{
	    getAjax:function () {
	     var successCallback =  (response) => {
	        console.log(response)
	        if(response.status==200){
	          this.list1 = response.data1
	          this.list2 = response.data2
	        }
	      }
	      var errorCallback =  (response) => {
	          console.log('服务器请求出错了')
	      }
	      this.$http.get(CURL+'/user/user/share?openid='+this.openid,{
	        data:{}
	      }).then(successCallback,errorCallback);
	    }
  	}
}


</script>
<style lang="scss" scoped>
.ssssss{
	background-color: #FFFFFF;
}
/*end*/
.dd_cntx2{
	display: none;
}
.dd_indexend{
	width: 100%;
	float: left;
	margin-top: 50px;
	text-align: center;
	font-size: 15px;
	color: #777;
}
/*cont*/
#dd_cntxafb{
	font-size: 12px;
	margin: 0 0 5px 0;
	padding-left: 10px;
	color: #777;
}
#dd_cntxafa{
	font-size: 12px;
	margin: 5px 0 5px 0;
	padding-left: 10px;
	color: #777;
}
#dd_cntxaf{
	margin-top: 15px;
	font-size: 16px;
	padding-left: 10px;
}

#dd_cntxapl{
	font-size: 13px;
	color: #bad565;
	padding-left: 10px;
	margin-bottom: 5px;
}
.dd_cntxap{
	width: 80%;
	float: left;
}
.dd_cntxaimg{
	margin: 15px 0 5px 5px;
	width: 16%;
	float: left;
}
.dd_ddh{
	height: 50px;
	line-height: 50px;
	padding-left: 15px;
	color: #777;
}
.dd_cntxa{
	width: 94%;
	background-color: #fafafa;
	float: left;
	margin-left: 3%;
	margin-right: 3%;
}
.dd_cntx{
	margin-top: 15px;
	float: left;
	width: 100%;
}
/*but*/
.dd_but{
	width: 49.5%;
	border-right: #eee solid 1px;
	background-color: #FFFFFF;
	color: #00a8d9;
}
.dd_buta{
	width: 49.5%;
	background-color: #FFFFFF;
}
.dd_buti{
	float: left;
	width: 100%;
	height: 45px;
	background-color: #FFFFFF;
	line-height: 45px;
	border-bottom: #eee solid 2px;
}
/*head*/
header{
  height: .4rem;
  background: #00a8d9;
  float: left;
  width: 100%;
  h1{
    margin-top: .2rem;
  }
}
.set_1{
	text-align: center;
    float: left;
    width: 88%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height:0;
}
.set_2{
	float: left;
	margin-top: -7px;
	margin-left: 3%;
	width: 5%;
	color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/fenxiang.vue